// Helper: find elements by local name (ignoring XML namespace prefixes like "c:", "xdr:", etc.)
// Uses getElementsByTagNameNS with wildcard namespace for reliable namespace-agnostic lookups.
export function qLocal(parent, localName) {
  if (!parent) return null;
  // getElementsByTagNameNS('*', name) matches elements with the given localName in ANY namespace
  const results = parent.getElementsByTagNameNS('*', localName);
  return results.length > 0 ? results[0] : null;
}

export function qLocalAll(parent, localName) {
  if (!parent) return [];
  return Array.from(parent.getElementsByTagNameNS('*', localName));
}

// Helper: find DIRECT child elements by local name only (not deep descendants)
export function qDirectChild(parent, localName) {
  if (!parent) return null;
  for (let i = 0; i < parent.childNodes.length; i++) {
    const child = parent.childNodes[i];
    if (child.nodeType === 1 && child.localName === localName) return child;
  }
  return null;
}
